import type { SVGProps } from 'react';
import * as React from 'react';

const ShiftReportsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="product-logo/shift-reports">
      <g id="Group 16">
        <path
          id="Vector"
          d="M2.21951 7.52026H15.2602C15.935 7.52026 16.4797 8.06498 16.4797 8.73978V21.7805C16.4797 22.4553 15.935 23 15.2602 23C7.39024 22.9919 1 16.6097 1 8.73978C1 8.06498 1.54472 7.52026 2.21951 7.52026Z"
          fill="#40E153"
        />
        <path
          id="Intersect"
          d="M15.2598 7.52051C15.585 7.52051 15.8793 7.64789 16.0977 7.85449L5.78027 18.1143C5.42289 18.472 5.4309 19.0571 5.80469 19.3984L5.9834 19.5615C2.93414 16.9462 1.00014 13.0687 1 8.74023C1 8.06544 1.54493 7.52051 2.21973 7.52051H15.2598Z"
          fill="#70FB8B"
        />
        <path
          id="Vector_2"
          d="M21.065 18.6667C20 18.6667 19.1382 17.8049 19.1382 16.7399V6.78863C19.1382 5.72359 18.2764 4.8618 17.2114 4.8618H7.26017C6.19513 4.8618 5.33334 4.00001 5.33334 2.93497C5.33334 1.86179 6.19513 1 7.26017 1H21.065C22.1301 1 22.9919 1.86179 22.9919 2.92683V16.7318C22.9919 17.7968 22.1301 18.6586 21.065 18.6586V18.6667Z"
          fill="#2AD53A"
        />
      </g>
    </g>
  </svg>
);
export default ShiftReportsIcon;
